import { Pipe, PipeTransform } from '@angular/core';
import { GbGrundstueckListEntryMeta, GrundstueckDetailEntryMeta, GrundstueckListEntry } from '../../../core/gb-api';
import { TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslateNamePipe } from './translate-name.pipe';

@Pipe({
  name: 'grundstueckArtLang',
  pure: false
})
export class GrundstueckArtLangPipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private translateMultiLanguage: TranslateNamePipe
  ) {
    keysToTranslate([
      'STOCKWERK_ausg',
      'LIEGENSCHAFT_ausg',
      'MITEIGENTUM_ausg',
      'UNBEKANNT_ausg',
      'FOLIO_ausg',
      'BERGWERK_ausg',
      'SDR_ausg',
      'STR_lang',
      'CFA_lang',
      'DPI_lang',
      'VEC_lang',
      'VIC_lang',
      'ADG_lang',
      'UEBRIGEART_lang'
    ]);
  }

  transform(entry: GrundstueckListEntry | GbGrundstueckListEntryMeta | GrundstueckDetailEntryMeta, languageChangeEvent = 'de'): string {
    if (entry.ligArt) {
      return this.liegenschaftUnterartLang(entry);
    }
    if (entry.grundstueckArt === 'SDR' && entry.sdrArt) {
      return this.translateService.instant(entry.grundstueckArt + '_ausg') + ' (' + this.translateService.instant(entry.sdrArt) + ')';
    }
    return this.translateService.instant(entry.grundstueckArt + '_ausg');
  }

  private liegenschaftUnterartLang(entry: GrundstueckListEntry | GbGrundstueckListEntryMeta | GrundstueckDetailEntryMeta): string {
    if (entry.codeUnterart) {
      return this.translateMultiLanguage.transform(entry.codeUnterart.text);
    }
    return this.translateService.instant(entry.ligArt + '_lang');
  }
}
